export default class DegreeModel {
  constructor(degreeInfo) {
    this._id = degreeInfo.id;
    this._name = degreeInfo.name;
    this._partnerId = degreeInfo.partnerId;
    this._partnerDegreeId = degreeInfo.partnerDegreeId;
    this._degreeId = degreeInfo.degreeId;
    this._degreeName = degreeInfo.degreeName;
    this._degreeIsActive = degreeInfo.degreeIsActive;
    this._degreeShortDescription = degreeInfo.degreeShortDescription;
    this._degreeLongDescription = degreeInfo.degreeLongDescription;
    this._degreeTooltip = degreeInfo.degreeTooltip;
    this._degreeImageLocationUrlPassive = degreeInfo.degreeImageLocationUrlPassive;
    this._degreeImageLocationUrlActive = degreeInfo.degreeImageLocationUrlActive;
    this._sortOrder = degreeInfo.sortOrder;
    this._required = degreeInfo.required;
  }

  get degreeId() {
    return this._degreeId;
  }
}
